import React from 'react';
import { Card } from '../../components/ui/card';
import { Construction } from 'lucide-react';

// Generic polished placeholder used by Ops modules not yet built.
export const OpsPlaceholder = ({ title, icon: Icon = Construction, description }) => (
  <div data-testid="ops-placeholder">
    <div className="mb-8">
      <h2 className="text-2xl md:text-3xl font-bold text-white">{title}</h2>
      {description && <p className="text-gray-400 mt-1">{description}</p>}
    </div>
    <Card className="bg-[#111111] border-gray-800 p-12 flex flex-col items-center justify-center text-center">
      <div className="bg-[#1F1F1F] rounded-2xl p-5 mb-5">
        <Icon size={40} className="text-[#D4AF37]" />
      </div>
      <h3 className="text-xl font-semibold text-white mb-2">{title} module</h3>
      <p className="text-gray-500 max-w-md">This module will be built in a future step.</p>
    </Card>
  </div>
);
